import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { safeJsonParse } from '../utils/jsonUtils'
import toast from 'react-hot-toast'
import { Button, Grid, TextField } from '@mui/material'
import validator from 'validator'
import { Box } from '@mui/system'
import axios from '../api/axios'
import { setAccountData } from '../features/account/account'

const Login = () => {
   // const account = useSelector((state) => state.account)
   const [account, setAccount] = useState(null)
   const navigate = useNavigate()
   const dispatch = useDispatch()
   const [mobileView, setMobileView] = useState(false)
   const [mail, setMail] = useState('')
   const [pass, setPass] = useState('')

   const SignIn = async () => {
      if (mail && validator.isEmail(mail)) {
         if (pass !== '') {
            let data = {
               mail,
               pass,
            }
            try {
               await axios
                  .post('signin', { data })
                  .then((result) => {
                     console.log(result)
                     if (result.data.login) {
                        const Data = result.data.data
                        delete Data.__v
                        delete Data.password

                        localStorage.setItem(
                           'accessToken',
                           JSON.stringify(Data.accessToken)
                        )
                        toast.success('Signed in successfully')
                        delete Data.accessToken
                        localStorage.setItem('user', JSON.stringify(Data))

                        if (Data.permission === 'admin') {
                           window.location.replace(
                              `${window.origin}/admin_dashboard`
                           )
                        } else {
                           window.location.replace(`${window.origin}/dashboard`)
                        }
                        // navigate('admin_dashboard')
                     } else {
                        toast.error(result.data.data)
                     }
                  })
            } catch (error) {
               if (process.env.REACT_APP_MODE) console.log(error)
            }
         } else {
            toast.error('Please enter your password')
         }
      } else {
         toast.error('Email is not valid')
      }
   }

   const getWidth = () =>
      window.innerWidth ||
      document.documentElement.clientWidth ||
      document.body.clientWidth

   useEffect(() => {
      const setResponsiveness = () => {
         getWidth() < 900 ? setMobileView(true) : setMobileView(false)
      }
      window.addEventListener('resize', setResponsiveness)
      return () => {
         window.removeEventListener('resize', setResponsiveness)
      }
   }, [])

   useEffect(() => {
      let user = localStorage.getItem('user')
      if (user) {
         let parse = safeJsonParse(user)
         setAccount(parse)
      }
   }, [])

   return (
      <Grid
         
         item
         xs={12}
         md={6}
         lg={6}
         sx={{
            minHeight: '100vh',
            bgcolor: '#F8FAFC',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            px: { xs: 3, sm: 6, md: 8 },
            py: 5,
         }}
      >
         <Box
            
            sx={{
               width: '100%',
               maxWidth: '440px',
               bgcolor: '#F8FAFC',
               p: mobileView ? 3 : 0,
               borderRadius: mobileView ? '16px' : 0,
               boxShadow: mobileView
                  ? '0 12px 40px rgba(16,24,40,0.12)'
                  : 'none',
            }}
         >


            {/* INTRO */}
            <Box sx={{ mb: 4 }}>
               <Box
                  sx={{
                     fontSize: { xs: '25px', md: '28px' },
                     fontWeight: 700,
                     color: '#172B4D',
                     mb: 1,
                  }}
               >
                  Welcome back
               </Box>

               <Box
                  sx={{
                     fontSize: '14px',
                     color: '#667085',
                  }}
               >
                  Sign in to continue to File Hub
               </Box>
            </Box>

            {/* EMAIL */}
            <Box sx={{ mb: 2.5 }}>
               <TextField
                  variant="outlined"
                  type="email"
                  fullWidth
                  label="Email"
                  InputLabelProps={{ shrink: true }}
                  value={mail}
                  autoComplete="email"
                  onChange={(e) => {
                     setMail(e.target.value)
                  }}
                  onKeyDown={(e) => {
                     if (e.key === 'Enter') SignIn()
                  }}
                  sx={{
                     '& .MuiOutlinedInput-root': {
                        height: '58px',
                        borderRadius: '10px',
                        bgcolor: '#F8FAFC',

                        '& fieldset': {
                           borderColor: '#D0D5DD',
                        },

                        '&:hover fieldset': {
                           borderColor: '#98A2B3',
                        },

                        '&.Mui-focused fieldset': {
                           borderColor: '#163A5F',
                           borderWidth: '1.5px',
                        },
                     },

                     '& .MuiInputLabel-root.Mui-focused': {
                        color: '#163A5F',
                     },

                     '& input:-webkit-autofill': {
                        WebkitBoxShadow:
                           '0 0 0 1000px #F8FAFC inset',
                        WebkitTextFillColor: '#172B4D',
                        caretColor: '#172B4D',
                     },

                     '& input:-webkit-autofill:hover': {
                        WebkitBoxShadow:
                           '0 0 0 1000px #F8FAFC inset',
                     },

                     '& input:-webkit-autofill:focus': {
                        WebkitBoxShadow:
                           '0 0 0 1000px #F8FAFC inset',
                     },
                  }}
               />
            </Box>

            {/* PASSWORD */}
            <Box sx={{ mb: 1.5 }}>
               <TextField
                  variant="outlined"
                  type="password"
                  label="Password"
                  InputLabelProps={{ shrink: true }}
                  fullWidth
                  value={pass}
                  autoComplete="current-password"
                  onChange={(e) => {
                     setPass(e.target.value)
                  }}
                  onKeyDown={(e) => {
                     if (e.key === 'Enter') SignIn()
                  }}
                  sx={{
                     '& .MuiOutlinedInput-root': {
                        height: '58px',
                        borderRadius: '10px',
                        bgcolor: '#F8FAFC',

                        '& fieldset': {
                           borderColor: '#D0D5DD',
                        },

                        '&:hover fieldset': {
                           borderColor: '#98A2B3',
                        },

                        '&.Mui-focused fieldset': {
                           borderColor: '#163A5F',
                           borderWidth: '1.5px',
                        },
                     },

                     '& .MuiInputLabel-root.Mui-focused': {
                        color: '#163A5F',
                     },

                     '& input:-webkit-autofill': {
                        WebkitBoxShadow:
                           '0 0 0 1000px #F8FAFC inset',
                        WebkitTextFillColor: '#172B4D',
                        caretColor: '#172B4D',
                     },

                     '& input:-webkit-autofill:hover': {
                        WebkitBoxShadow:
                           '0 0 0 1000px #F8FAFC inset',
                     },

                     '& input:-webkit-autofill:focus': {
                        WebkitBoxShadow:
                           '0 0 0 1000px #F8FAFC inset',
                     },
                  }}
               />
            </Box>

            {/* FORGOT PASSWORD */}
            <Box
               sx={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                  mb: 3,
               }}
            >
               <Box
                  component="span"
                  onClick={() => {
                     navigate('forgot-password')
                  }}
                  sx={{
                     cursor: 'pointer',
                     color: '#163A5F',
                     fontSize: '13px',
                     fontWeight: 600,

                     '&:hover': {
                        color: '#00A9CE',
                     },
                  }}
               >
                  Forgot password?
               </Box>
            </Box>

            {/* SIGN IN */}
            <Button
               variant="contained"
               fullWidth
               onClick={SignIn}
               sx={{
                  height: '48px',
                  bgcolor: '#163A5F',
                  borderRadius: '9px',
                  fontSize: '15px',
                  fontWeight: 700,
                  boxShadow: '0 3px 8px rgba(22,58,95,0.20)',

                  '&:hover': {
                     bgcolor: '#0D2740',
                     boxShadow: '0 5px 12px rgba(22,58,95,0.24)',
                  },
               }}
            >
               Sign in
            </Button>

            {/* REGISTER */}
            <Box
               sx={{
                  mt: 4,
                  pt: 3,
                  borderTop: '1px solid #EAECF0',
                  textAlign: 'center',
                  color: '#667085',
                  fontSize: '14px',
               }}
            >
               Don't have an account yet?{' '}

               <Box
                  component="span"
                  onClick={() => {
                     navigate('/register')
                  }}
                  sx={{
                     cursor: 'pointer',
                     ml: '3px',
                     color: '#163A5F',
                     fontWeight: 700,

                     '&:hover': {
                        color: '#00A9CE',
                     },
                  }}
               >
                  Sign up
               </Box>
            </Box>
         </Box>
      </Grid>
   )
}
export default Login
